<div class="modal-header shadow-sm">
    <div class="d-flex flex-column">   
        <h6 class="modal-title d-block">Invite End-User</h6>
        <span class="text-muted d-block">Send a registration link so this end user can create their account.</span>
    </div>
    <button type="button" class="btn-close white align-self-start" aria-label="Close" (click)="modalRef.close()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="inviteForm" autocomplete="off">
        <div formGroupName="demographic">
        <div class="row gx-3 mb-2">
            <div class="col-6">
                <label for="firstName" class="form-label">First Name *</label>
                <app-input
                  [name]="'firstName'"
                  [type]="'text'"
                  [control]="demographic.controls['firstName']"
                  [submitted]="submitted"
                  [required]="true"
                ></app-input>
            </div>
            <div class="col-6">
                <label for="lastName" class="form-label">Last Name *</label>
                <app-input
                  [name]="'lastName'"
                  [type]="'text'"
                  [control]="demographic.controls['lastName']"
                  [submitted]="submitted"
                  [required]="true"
                ></app-input>
            </div>
      </div>
      <div class="md-form mb-2">
        <label for="email" class="form-label">Email Address *</label>
        <app-input
          [name]="'email'"
          [type]="'text'"
          [control]="demographic.controls['email']"
          [submitted]="submitted"
          [required]="true"
        ></app-input>
      </div>
      <div class="md-form mb-2">
        <label for="organizationId" class="form-label">Organization *</label>
        <app-select [form]="inviteForm" [placeholder]="organizationsList.length ? 'Select Organization' : 'Loading...'" [control]="inviteForm.controls['organizationId']" [controlName]="'organizationId'" [filter]="false" [submitted]="submitted" [data]="organizationsList" [name]="'displayName'" [value]="'id'" [disabled]="isOrgReadonly" (emitSelectedValue)="receiveSelectedValue($event)" class="mb-2"></app-select>
      </div>
      <div class="md-form mb-2">
        <label for="advocateId" class="form-label">Advocate *</label>
        <app-select [form]="inviteForm" [placeholder]="'Select Advocate'" [control]="inviteForm.controls['advocateId']" [controlName]="'advocateId'" [filter]="false" [submitted]="submitted" [data]="advocateList" [name]="'displayName'" [value]="'id'" [disabled]="isAdvocateReadonly" (emitSelectedValue)="receiveSelectedValue($event)" class="mb-2"></app-select>
      </div>
    </div>
    </form>
  </div>
  <div class="modal-footer justify-content-between pt-0">
    <button type="button" class="btn btn-gray-light" (click)="modalRef.close()">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="sendInvite()"
      [disabled]="inviteForm.invalid || loading"
    >
      <span class="spinner-grow spinner-grow-sm" *ngIf="loading"></span>
      Send Invite
    </button>
  </div>
